import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import ViewFile from '@acri-tools/react-tools/components/ViewFile/ViewFile';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import { isAdmin } from '@acri-tools/react-tools/utils/_user_manager/login';
import request from '@acri-tools/react-tools/utils/request';
import classNames from 'classnames';
import React,{Component} from 'react';
import { get_categroy_group } from '../../utils/documents';
import CreateDocument from '../CreateDocument/CreateDocument';
import UpdateDocument from '../UpdateDocument/UpdateDocument';
import { create_toast, getDateString, getDateTimeString } from '@acri-tools/react-tools/utils'

import './Documents.css';
import LoadingData from '../LoadingData/LoadingData';
import DataTable from '../DataTable/DataTable';

interface Props{
    category: string

    className?:string
    default_toggled?:boolean
}
interface State{
    documents?: Array<any>
    sorted?: Array<any>
    count?:number
    opened_document?: any

    loading: boolean
    create: boolean
    update?: any
    toggled: boolean


    sort?: {
        column: string,
        direction: 'asc'|'desc'
    }
}


class Documents extends Component<Props,State>{

    constructor(props:Props){
        super(props);
        this.state = {
            loading:false,
            create: false,
            toggled: !!this.props.default_toggled
        }
    }

    componentDidMount(){
        this.fetch(true);
    }

    componentDidUpdate(prevProps:Props){
        if(this.props.category !== prevProps.category){
            this.fetch(true);
        }
    }

    fetch = async(load?:boolean) =>{
        if(load) this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/documents`, {
                method: 'get',
                params:{
                    count: true,
                    filter: `category eq '${this.props.category}'`,
                    limit: "null"
                }
            })

            this.setState({ 
                count: res.data.count, 
                documents: res.data.value
                // .map((d:any)=>{
                //     return { ...d, modification_date: d.modification_date ? getDateString(new Date(d.modification_date), true) : undefined }
                // }),
            });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch` });
            toast_request_error(e);
        }
        finally {
            if(load) this.setState({ loading: false })
        }
    }



    sort_data_click = async(column: string, direction?:'asc'|'desc') =>{
        if(direction){
            if(this.state.sort){
                if(this.state.sort.column === column && this.state.sort.direction === direction)
                    return await this.setState({ sort: undefined, sorted: undefined })
            }
        }
        else{
            if(column === this.state.sort?.column){
                if(this.state.sort.direction === 'asc')
                    direction = 'desc';
                else return await this.setState({ sort: undefined, sorted: undefined })
            }
            else{
                direction = 'asc';  
            }
        }
        await this.setState({
            sort: { column, direction }
        })
        this.sort_data();
    }



    sort_data = () =>{
        if(this.state.sort){
            let sort_function;
            let { column } = this.state.sort;

            // Date
             if(['modification_date'].includes(column)){
                if(this.state.sort.direction === 'asc')
                    sort_function = (a:any, b:any) => {
                        // return a[column] - b[column];
                        return (new Date(a[column])).getTime() - (new Date(b[column])).getTime();
                        // return new Date(b.date) - new Date(a.date);
                    }
                else
                    sort_function = (a:any, b:any) => {
                        return (new Date(b[column])).getTime() - (new Date(a[column])).getTime();
                        // return b[column] - a[column];
                        // return parseFloat(b[column]) - parseFloat(a[column]);
                    }
            }
            // Numerical
            else if(['downloads', 'version'].includes(column)){
                if(this.state.sort.direction === 'asc')
                    sort_function = (a:any, b:any) => {
                        return parseFloat(a[column]) - parseFloat(b[column]);
                    }
                else
                    sort_function = (a:any, b:any) => {
                        return parseFloat(b[column]) - parseFloat(a[column]);
                    }
            }
            // Alphabetical
            else{
            // else if(['name'].includes(column)){
                if(this.state.sort.direction === 'asc')
                    sort_function = (a:any, b:any) => {
                        return a[column]?.localeCompare(b[column]);
                    }
                else
                    sort_function = (a:any, b:any) => {
                        return b[column]?.localeCompare(a[column]);
                    }
            }

            // let { filtered, sorted } = this.state;
            let sorted = this.state.sorted || [ ...this.state.documents || [] ];
            sorted.sort(sort_function);
            this.setState({ sorted })
        }
    }

    get_data = () =>{
        return this.state.sorted || this.state.documents;
    }


    render(){
        return (
            <>
                {
                    this.state.opened_document &&
                    <ViewFile
                        hide_details
                        hide_download
                        opened={!!this.state.opened_document}
                        close={()=>{ this.setState({ opened_document: null }) }}
                        path={this.state.opened_document.path}
                    />
                }
                {
                    isAdmin() &&
                    <>
                        {/* CREATE */}
                        <Modal
                            className="medium"
                            opened={this.state.create}
                            close={()=>{ this.setState({ create: false }) }}
                        >
                            <div className="modal-title">
                                ADD DOCUMENT <ModalClose close={()=>{ this.setState({ create: false }) }}/>
                            </div>
                            <div className="modal-content">
                                <CreateDocument
                                    onCreate={()=>{
                                        this.fetch();
                                        this.setState({ create: false });
                                    }}
                                    category={this.props.category}
                                />
                            </div>
                        </Modal>

                        {/* UPDATE */}
                        {
                            this.state.update &&
                            <Modal
                                className="medium"
                                opened={!!this.state.update}
                                close={()=>{ this.setState({ update: undefined }) }}
                            >
                                <div className="modal-title">
                                    UPDATE DOCUMENT <ModalClose close={()=>{ this.setState({ update: undefined }) }}/>
                                </div>
                                <div className="modal-content">
                                    <UpdateDocument
                                        document={this.state.update}
                                        onUpdate={()=>{
                                            this.fetch();
                                            this.setState({ update: undefined });
                                        }}
                                    />
                                </div>
                            </Modal>
                        }
                    </>
                }
                <div
                    className={`${classNames({
                        "documents": true,
                        "toggled": this.state.toggled
                    })} ${this.props.className || ''}`}
                >
                    <div className="documents-header" onClick={()=>{ this.setState({ toggled: !this.state.toggled }) }}>
                        <div className="documents-title">
                            {
                                this.state.count ?
                                <div className="documents-count">
                                    { this.state.count }
                                </div>
                                :   undefined
                            }
                            { this.props.category }
                        </div>
                        <div className="documents-operations">
                            {
                                isAdmin() &&
                                <>
                                    <div 
                                        className="custom-button small inline blue"
                                        onClick={(e)=>{
                                            e.stopPropagation();
                                            this.setState({ create: true });
                                        }}
                                    >
                                        <i className="fas fa-plus"/> ADD
                                    </div>
                                </>
                            }
                            
                            <div className="documents-toggle">
                                <i className="fas fa-chevron-right"/>
                            </div>
                        </div>
                        
                    </div>
                    <div className="documents-data">
                        <div className="documents-data-wrapper scrollbar">
                            <LoadingData
                                loading={this.state.loading} no_data={!this.state.documents}
                                no_data_message="No Documents"
                            >

                                {
                                    this.state.documents &&
                                    <DataTable
                                        hide_search
                                        show_all
                                        body_max_height={250}
                                        data={this.state.documents}
                                        // fixed_width={{
                                        //     'collection': this.percentage_size,
                                        // }}
                                        headers={[
                                            {
                                                label: <><i className="fas fa-heading"/> Name</>,
                                                key: 'name'
                                            },
                                            {
                                                label: <><i className="fas fa-download"/> Downloads</>,
                                                key: "downloads"
                                            },
                                            {
                                                label: <><i className="fas fa-code-branch"/> Version</>,
                                                key: "version"
                                            },
                                            {
                                                label: <><i className="fas fa-calendar"/> Last Modification</>,
                                                key: "modification_date"
                                            },
                                            {
                                                label: <><i className="fas fa-file"/> Download</>,
                                                key: "download"
                                            }
                                        ]}
                                        field_output={{
                                            'name': (row) => <div 
                                                className="document-name"
                                                onClick={()=>{ this.setState({ opened_document: row }) }}
                                            >
                                                { row.name }
                                            </div>,
                                            'downloads': (row) => <>{ row.downloads } download{row.downloads !== 1 ? 's' : ''}</>,
                                            'version': (row) => <>{ row.version?.toFixed(1) }</>,
                                            'modification_date': (row) => 
                                                <>{ row.modification_date ? getDateString(new Date(row.modification_date), true) : '' }</>,
                                            'download': (row)=>
                                                <div className="document-operations">
                                                    <a 
                                                        className="custom-button small inline blue"
                                                        download
                                                        href={`${API_URL}/api/v1/documents/${row.id}/file`}
                                                        onClick={()=>{
                                                            row.downloads++;
                                                            this.forceUpdate();
                                                        }}
                                                    >
                                                        <i className="fas fa-file"/> download
                                                    </a>
                                                    {
                                                        isAdmin() &&
                                                        <>
                                                            <div
                                                                className="custom-button small inline blue icon-only tt"
                                                                onClick={()=>{
                                                                    this.setState({
                                                                        update: {
                                                                            ...row,
                                                                            category_group: get_categroy_group(row.category)
                                                                        }
                                                                    })
                                                                }}
                                                            >
                                                                <i className="fas fa-pen"/>
                                                                <div className="tt-tooltip">
                                                                    update
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="custom-button small inline red icon-only tt"
                                                                onClick={()=>{ this.delete(row) }}
                                                            >
                                                                <i className="fas fa-times"/>
                                                                <div className="tt-tooltip">
                                                                    delete
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                        }}
                                        // operations={isAdmin() ? this.get_operations : undefined}
                                        fixed_width={{
                                            'name': '430px',
                                            'version': '110px',
                                            'modification_date': '170px',
                                        }}
                                        sort_columns={{
                                            'name': { filter: 'alphabetical' },
                                            'downloads': { filter: 'numerical' },
                                            'version': { filter: 'numerical' },
                                            'modification_date': { filter: 'date' },
                                        }}
                                    />
                                }
                            </LoadingData>
                            {
                                // this.state.loading ?
                                //     <div className="centered">
                                //         <Spinner height={16}/>
                                //     </div>
                                // :
                                // !this.state.documents ?
                                //     <div className="no-data">No Documents</div>
                                // :
                                // <table className="table-damps">
                                //     <thead>
                                //         <tr>
                                //             {
                                //                 [
                                //                     {
                                //                         header: <><i className="fas fa-heading"/> Name</>,
                                //                         column: 'name'
                                //                     },
                                //                     {
                                //                         header: <><i className="fas fa-download"/> Downloads</>,
                                //                         column: 'downloads'
                                //                     },
                                //                     {
                                //                         header: <><i className="fas fa-code-branch"/> Version</>,
                                //                         column: 'version'
                                //                     },
                                //                     {
                                //                         header: <><i className="fas fa-calendar"/> Last Modification</>,
                                //                         column: 'modification_date'
                                //                     }
                                //                 ].map((header)=>(
                                //                     <th 
                                //                         className={classNames({
                                //                             "documents-sort-wrapper": true,
                                //                             "active": this.state.sort?.column === header.column
                                //                         })}
                                //                     >
                                //                         <div 
                                //                             className={classNames({
                                //                                 "documents-sort": true,
                                //                                 "active": this.state.sort?.column === header.column
                                //                             })}
                                //                             onClick={(e)=>{ e.stopPropagation(); this.sort_data_click(header.column) }}
                                //                         >
                                //                             <div className={classNames({
                                //                                 "documents-sort-column": true
                                //                             })}>
                                //                                 { header.header }
                                //                             </div>
                                //                             <div className="documents-sort-directions">
                                //                                 <div 
                                //                                     className={classNames({
                                //                                         "documents-sort-direction": true,
                                //                                         "active": this.state.sort?.column === header.column 
                                //                                             && this.state.sort?.direction === 'asc'
                                //                                     })}
                                //                                     onClick={(e)=>{ e.stopPropagation(); this.sort_data_click(header.column, "asc") }}
                                //                                 >
                                //                                     <i className="fas fa-sort-up"/>
                                //                                 </div>
                                //                                 <div 
                                //                                     className={classNames({
                                //                                         "documents-sort-direction": true,
                                //                                         "active": 
                                //                                             this.state.sort?.column === header.column 
                                //                                             && this.state.sort?.direction === 'desc'
                                //                                     })}
                                //                                     onClick={(e)=>{ e.stopPropagation(); this.sort_data_click(header.column, 'desc') }}
                                //                                 >
                                //                                     <i className="fas fa-sort-down"/>
                                //                                 </div>
                                //                             </div>

                                //                         </div>
                                //                     </th>
                                //                 ))
                                //             }
                                //             <th><i className="fas fa-file"/> Download</th>
                                //         </tr>
                                //         {/* <tr>
                                //             <th><i className="fas fa-heading"/> Name</th>
                                //             <th><i className="fas fa-download"/> Downloads</th>
                                //             <th><i className="fas fa-code-branch"/> Version</th>
                                //             <th><i className="fas fa-calendar"/> Last Modification</th>
                                //             <th><i className="fas fa-file"/> Download</th>
                                //         </tr> */}
                                //     </thead>
                                //     <tbody>
                                //         {
                                //             this.get_data()?.map((row: any, key: number) => (
                                //                 <tr key={key}>
                                //                     <td>
                                //                         <div 
                                //                             className="document-name"
                                //                             onClick={()=>{ this.setState({ opened_document: row }) }}
                                //                         >
                                //                             { row.name }
                                //                         </div>
                                //                     </td>
                                //                     <td>{ row.downloads } download{row.downloads !== 1 ? 's' : ''}</td>
                                //                     <td>{ row.version?.toFixed(1) }</td>
                                //                     <td>{ row.modification_date ? getDateString(new Date(row.modification_date), true) : '' }</td>
                                //                     {/* <td>{ getDateString(new Date(d.modification_date), true)row.modification_date }</td> */}
                                //                     <td>
                                //                         <div className="document-operations">
                                //                             <a 
                                //                                 className="custom-button small inline blue"
                                //                                 download
                                //                                 href={`${API_URL}/api/v1/documents/${row.id}/file`}
                                //                                 onClick={()=>{
                                //                                     row.downloads++;
                                //                                     this.forceUpdate();
                                //                                 }}
                                //                             >
                                //                                 <i className="fas fa-file"/> download
                                //                             </a>
                                //                             {
                                //                                 isAdmin() &&
                                //                                 <>
                                //                                     <div
                                //                                         className="custom-button small inline blue icon-only tt"
                                //                                         onClick={()=>{
                                //                                             this.setState({
                                //                                                 update: {
                                //                                                     ...row,
                                //                                                     category_group: get_categroy_group(row.category)
                                //                                                 }
                                //                                             })
                                //                                         }}
                                //                                     >
                                //                                         <i className="fas fa-pen"/>
                                //                                         <div className="tt-tooltip">
                                //                                             update
                                //                                         </div>
                                //                                     </div>
                                //                                     <div
                                //                                         className="custom-button small inline red icon-only tt"
                                //                                         onClick={()=>{ this.delete(row) }}
                                //                                     >
                                //                                         <i className="fas fa-times"/>
                                //                                         <div className="tt-tooltip">
                                //                                             delete
                                //                                         </div>
                                //                                     </div>
                                //                                 </>
                                //                             }
                                //                         </div>
                                //                     </td>
                                //                 </tr>
                                //             ))
                                //         }
                                //     </tbody>
                                // </table>
                            }
                        </div>
                    </div>

                </div>
            </>
        );
    }


    delete = async(row:any) =>{
        if(window.confirm(`Are you sure you want to remove document ${row.name} ?`)){
            try{
                await request(`${API_URL}/api/v1/documents/${row.id}`,{
                    method:'delete'
                })
                this.fetch();

                create_toast({ type: 'success', message: `Successfully removed data maintenance ${row.name}` });
            }
            catch(e:any){
                axiosErrorHandler( e, { 
                    functionName: 'delete'
                })
                toast_request_error(e);
            }
            finally{
            }
            
        }
    }

};

export default (Documents)